import { forwardRef, Ref } from 'react'

import { FormError } from 'shared/atoms'
import { Label } from 'shared/atoms'

import type { TextareaProps } from './types'
import { cn } from 'utils/style'

export const Textarea = forwardRef(
	(
		{
			id,
			label,
			name,
			placeholder,
			onChange,
			disabled,
			className,
			error,
			letters,
			maxLetterCount,
			required,
			rows = 3
		}: TextareaProps,
		ref: Ref<HTMLTextAreaElement>
	) => {
		return (
			<div className={cn('flex flex-col gap-y-1.5', className)}>
				<div className="flex items-center justify-between">
					<Label htmlFor={id} required={required} text={label} />
					{maxLetterCount && (
						<span className="text-[11px] tabular-nums text-muted-foreground">
							{letters}/{maxLetterCount}
						</span>
					)}
				</div>
				<textarea
					id={id}
					rows={rows}
					className={cn(
						'w-full resize-y rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground outline-none transition placeholder:text-muted-foreground/60 focus:border-primary focus:ring-2 focus:ring-primary/20 disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground',
						error && 'border-danger focus:border-danger focus:ring-danger/20'
					)}
					name={name}
					placeholder={placeholder}
					ref={ref}
					disabled={disabled}
					onChange={onChange}
				/>
				<FormError text={error?.message} />
			</div>
		)
	}
)
